import { api } from './api-client';
import type { FilterGroup, DauData } from '@/types';

type DauParams = {
  projectId: string;
  interval: string;
  startDate: Date;
  endDate: Date;
  filterGroups?: FilterGroup[];
};

export const DailyActiveUsersService = {
  getDau: async ({ projectId, interval, startDate, endDate, filterGroups }: DauParams) => {
    const { data } = await api.post<{ data: DauData }>(`/analytics/dau`, {
      projectId, interval, startDate, endDate, filterGroups,
    });
    return data;
  },
};
